import { useSelector } from 'react-redux';

const useLocation = () => {
  const { ip, country } = useSelector((state) => state.location);
  return { ip, country };
};

export default useLocation;
